import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmMsgComponent } from 'app/components/confirm-msg/confirm-msg/confirm-msg.component';
import { DashboardService } from 'app/services/dashboard.service';
import { AlertService } from 'app/shared/alert/alert.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'downloads',
    templateUrl: './downloads.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'downloads',
})
export class DownloadsComponent {

    availableDownloads:any;
    @ViewChild('messagesOrigin') private _messagesOrigin: MatButton;
    @ViewChild('messagesPanel') private _messagesPanel: TemplateRef<any>;

    messages: any;
    unreadCount: number = 0;
    private _overlayRef: OverlayRef;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _overlay: Overlay,
        private _viewContainerRef: ViewContainerRef,
        private dashboardService: DashboardService,
        private dialog: MatDialog,
        private alertService:AlertService
    )
    {
        this.dialog.closeAll();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        this.dialog.closeAll();
        // Subscribe to message changes
        this.download();
        this.offset = (new Date().getTimezoneOffset());
        //this._calculateUnreadCount();

    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();

        // Dispose the overlay
        if ( this._overlayRef )
        {
            this._overlayRef.dispose();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Open the messages panel
     */
    offset:number;

    download(): void {
       this.dashboardService.getDownloadDetails().subscribe((res) => {
            if(res != undefined){
                this.availableDownloads = res.responseData[0].records.reverse();                
                localStorage.setItem(
                    'downloads',
                    JSON.stringify(this.availableDownloads)
                ); 
                //this._calculateUnreadCount();

            }
        });
    }

    /*private _calculateUnreadCount(): void
    {
        let count = 0;

        if ( this.availableDownloads && this.availableDownloads.length )
        {

            count = this.availableDownloads.filter(download => !download.is_downloaded).length;
        }

        this.unreadCount = count;
        console.log("=========================unreadCount====================="+this.unreadCount);
    }*/

    openPanel(): void
    {
        // Return if the messages panel or its origin is not defined
        if ( !this._messagesPanel || !this._messagesOrigin )
        {
            return;
        }

        // Create the overlay if it doesn't exist
        if ( !this._overlayRef )
        {
            this._createOverlay();
        }

        // Attach the portal to the overlay
        this._overlayRef.attach(new TemplatePortal(this._messagesPanel, this._viewContainerRef));
        this.download();
    }

    /**
     * Close the messages panel
     */
    closePanel(): void
    {
        this._overlayRef.detach();
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Create the overlay
     */
    private _createOverlay(): void
    {
        // Create the overlay
        this._overlayRef = this._overlay.create({
            hasBackdrop     : true,
            backdropClass   : 'fuse-backdrop-on-mobile',
            scrollStrategy  : this._overlay.scrollStrategies.block(),
            positionStrategy: this._overlay.position()
                                  .flexibleConnectedTo(this._messagesOrigin._elementRef.nativeElement)
                                  .withLockedPosition(true)
                                  .withPush(true)
                                  .withPositions([
                                      {
                                          originX : 'start',
                                          originY : 'bottom',
                                          overlayX: 'start',
                                          overlayY: 'top'
                                      },
                                      {
                                          originX : 'start',
                                          originY : 'top',
                                          overlayX: 'start',
                                          overlayY: 'bottom'
                                      },
                                      {
                                          originX : 'end',
                                          originY : 'bottom',
                                          overlayX: 'end',
                                          overlayY: 'top'
                                      },
                                      {
                                          originX : 'end',
                                          originY : 'top',
                                          overlayX: 'end',
                                          overlayY: 'bottom'
                                      }
                                  ])
        });

        // Detach the overlay from the portal on backdrop click
        this._overlayRef.backdropClick().subscribe(() => {
            this._overlayRef.detach();
        });
    }

    onDownloadFileClicked(url){
        location.href = url;
    }

    deleteDownloadRecord(id:any){
        this.dialog.closeAll();
        let dialogRef = this.dialog.open(ConfirmMsgComponent, {
                hasBackdrop: false,
                closeOnNavigation: true,
        });
        dialogRef.afterClosed().subscribe((data) => {
            if(data){
                this.dashboardService.deleteDownloadRecord(id).subscribe((res) => {
                    if(res){
                        this.alertService.success(res.responseStatus.responseMessage);
                        this.download();
                    }
                });   
            }        
        });
        
    }
}
